export default __webpack_public_path__ + "assets/langSwitcher3.png";